export const SHOW_MEDICAL_QUOTE = "SHOW_MEDICAL_QUOTE"
export const GET_MI_CUSTOMER_MASTERS = "GET_MI_CUSTOMER_MASTERS"
export const SAVE_MI_CUSTOMER_NEW_ENQUIRY = "SAVE_MI_CUSTOMER_NEW_ENQUIRY"
export const UPDATE_BASIC_QUOTE_PARAMS = "UPDATE_BASIC_QUOTE_PARAMS"
export const HANDLE_NEXT_STEP = "HANDLE_NEXT_STEP"
export const ADD_SPONSOR_TO_QUOTE = "ADD_SPONSOR_TO_QUOTE"
export const UPDATE_BASIC_MEMBER_INFO_LIST = "UPDATE_BASIC_MEMBER_INFO_LIST"
export const UPDATE_BASIC_MEMBER_INFO = "UPDATE_BASIC_MEMBER_INFO"
export const ADD_MEMBER = "ADD_MEMBER"
export const DELETE_MEMBER = "DELETE_MEMBER"
export const DELETE_ALL_MEMBERS = "DELETE_ALL_MEMBERS"
export const TOGGLE_CONFRIM_POPUP = "TOGGLE_CONFRIM_POPUP"
export const CONFIRM_YES = "CONFIRM_YES";
export const CONFIRM_NO = "CONFIRM_NO";
export const SAVE_BASIC_MEMBER_INFO = "SAVE_BASIC_MEMBER_INFO";
export const UPDATE_PAYMENT_TRANSACTION_PARAMS = "UPDATE_PAYMENT_TRANSACTION_PARAMS";
export const SHOW_TERMS_COND_POPUP = "SHOW_TERMS_COND_POPUP";
export const GET_QUOTE_MEMBERS = "GET_QUOTE_MEMBERS";
export const GET_PAYMENT_INFORMATION_END_MICUSTOMER = "GET_PAYMENT_INFORMATION_END_MICUSTOMER";
export const TOGGLE_SEARCH = "TOGGLE_SEARCH";
export const QUOTE_SEARCH_RESULT = "QUOTE_SEARCH_RESULT";
export const UPDATE_QUOTE_SEARCH_PARAMS = "UPDATE_QUOTE_SEARCH_PARAMS"
export const UPDATE_PROSPECT_INFORMATION_PARAMS = "UPDATE_PROSPECT_INFORMATION_PARAMS"
export const UPDATE_MEMBER_INFORMATION_PARAMS = "UPDATE_MEMBER_INFORMATION_PARAMS"
export const GET_MEMBER_DETAILS_BY_QUOTE_ID = "GET_MEMBER_DETAILS_BY_QUOTE_ID"
export const RESTORE_STATE = "RESTORE_STATE"
export const SAVE_UAE_PASS_USER_INFO = "SAVE_UAE_PASS_USER_INFO"
export const SET_PRODUCT_ID = "SET_PRODUCT_ID"








export const RESET_PLAN_SELCTION = "RESET_PLAN_SELCTION"
export const GET_PLAN_LIST_END = "GET_PLAN_LIST_END"
export const UPDATE_PLAN_LIST_PARAMS = "UPDATE_PLAN_LIST_PARAMS"
export const UPDATE_PRODUCT_SELECTION_PARAMS = "UPDATE_PRODUCT_SELECTION_PARAMS"
export const RESET_PRODUCT_SELCTION = "RESET_PRODUCT_SELCTION"
export const GET_PLANS_BY_VISA_EMIRATES_END = "GET_PLANS_BY_VISA_EMIRATES_END"
export const GET_INDIVIDUAL_PLANS_TOB_END = "GET_INDIVIDUAL_PLANS_TOB_END"
export const UPDATE_PLAN_TOB_PARAMS = "UPDATE_PLAN_TOB_PARAMS"
export const RESET_PLAN_TOB_PARAMS = "RESET_PLAN_TOB_PARAMS"
export const RESET_PRODUCT_SELECTION_PARAMS = "RESET_PRODUCT_SELECTION_PARAMS"
export const RESET_PLAN_SELECTION_PARAMS = "RESET_PLAN_SELECTION_PARAMS"
export const GET_INDIVIDUAL_BENEFIT_STRUCUTRE_END = "GET_INDIVIDUAL_BENEFIT_STRUCUTRE_END"
export const RESET_BENEFIT_STRUCTURE_PARAMS = "RESET_BENEFIT_STRUCTURE_PARAMS"
export const UPDATE_PRODUCT_SELECTION_CHECKBOX_CHANGE_PARAMS = "UPDATE_PRODUCT_SELECTION_CHECKBOX_CHANGE_PARAMS"
export const UPDATE_PLAN_SELECTION_CHECKBOX_CHANGE_PARAMS = "UPDATE_PLAN_SELECTION_CHECKBOX_CHANGE_PARAMS"
export const GET_PREMIUM_SUMMARY_END = "GET_PREMIUM_SUMMARY_END"
export const GET_PLANS_BY_PRODUCT_AND_PORTAL_TYPE_ID_END = "GET_PLANS_BY_PRODUCT_AND_PORTAL_TYPE_ID_END"
export const GET_BASE_PREMIUM_BY_PLAN_END = "GET_BASE_PREMIUM_BY_PLAN_END"
export const RESET_BASE_PREMIUM_BY_PLAN = "RESET_BASE_PREMIUM_BY_PLAN"
export const UPDATE_INDICATIVE_QUOTE_PARAMS = "UPDATE_INDICATIVE_QUOTE_PARAMS"
export const CLEAR_PRODUCT_SELECTION_PLANS_CHECKBOXES = "CLEAR_PRODUCT_SELECTION_PLANS_CHECKBOXES"
export const GET_MEMBER_BASE_PLAN_END = "GET_MEMBER_BASE_PLAN_END"
export const TOGGLE_MEMBER_BASE_PREM_MODAL = "TOGGLE_MEMBER_BASE_PREM_MODAL"
export const TOGGLE_PLAN_SELECT_MODAL = "TOGGLE_PLAN_SELECT_MODAL"
export const TOGGLE_PLAN_TOB_MODAL = "TOGGLE_PLAN_TOB_MODAL"
export const TOGGLE_PLAN_COMPARE = "TOGGLE_PLAN_COMPARE"
export const SAVE_PLAN_DETAILS = "SAVE_PLAN_DETAILS"
export const UPDATE_PLAN_SELECTION = "UPDATE_PLAN_SELECTION"

export const GET_MAF_QUESTIONS_END = "GET_MAF_QUESTIONS_END"
export const GET_MAF_ANSWERS_END = "GET_MAF_ANSWERS_END"
export const UPDATE_MEDICAL_FORM_PARAMS = "UPDATE_MEDICAL_FORM_PARAMS"
export const UPDATE_SUB_MEDICAL_FORM_PARAMS = "UPDATE_SUB_MEDICAL_FORM_PARAMS"
export const UPDATE_MEDICAL_FORM_REMARKS = "UPDATE_MEDICAL_FORM_REMARKS"
export const UPDATE_MEDICAL_FORM_REMARKS_DATE = "UPDATE_MEDICAL_FORM_REMARKS_DATE"
export const UPDATE_MEDICAL_FORM_LIST = "UPDATE_MEDICAL_FORM_LIST"
export const UPDATE_MAF_INFO = "UPDATE_MAF_INFO"
export const CHECK_SHORT_QUESTIONS_MAF_STATUS_MICUSTOMER = "CHECK_SHORT_QUESTIONS_MAF_STATUS_MICUSTOMER"
export const GET_PLAN_COMPARE_STRUCUTRE_END = "GET_PLAN_COMPARE_STRUCUTRE_END"

export const CHECK_DOCUMENT_TAB_TYPE = "CHECK_DOCUMENT_TAB_TYPE"
export const ADD_NEW_DOCUMENT = "ADD_NEW_DOCUMENT"
export const CLEAR_DOCUMENT_LIST = "CLEAR_DOCUMENT_LIST"
// export const UPDATE_DOCUMENT_CHECKBOX_PARAMS = "UPDATE_DOCUMENT_CHECKBOX_PARAMS"
// export const GET_MEMBER_DOCUMENT_MASTERS_END = "GET_MEMBER_DOCUMENT_MASTERS_END"
export const GET_MEMBER_DOCUMENT_LIST_END = "GET_MEMBER_DOCUMENT_LIST_END"
export const UPDATE_DOCUMENT_PARAMS_END = "UPDATE_DOCUMENT_PARAMS_END"
export const UPDATE_FILE_CHANGE_END = "UPDATE_FILE_CHANGE_END"
// export const UPDATE_HAS_CHECKBOX_IN_DOCUMENTS = "UPDATE_HAS_CHECKBOX_IN_DOCUMENTS"
export const DELETE_DOCUMENT_FROM_GRID = "DELETE_DOCUMENT_FROM_GRID"
export const UPDATE_DOCUMENTS_TABLE_ID = "UPDATE_DOCUMENTS_TABLE_ID"

export const GET_QUOTE_DOCUMENT_MASTERS_END = "GET_QUOTE_DOCUMENT_MASTERS_END"
// export const GET_QUOTE_DOCUMENT_LIST_END = "GET_QUOTE_DOCUMENT_LIST_END"

// export const UPDATE_QUOTE_CUSTOMER_DOCUMENTS_TABLE_ID = 'UPDATE_QUOTE_CUSTOMER_DOCUMENTS_TABLE_ID'
export const SHOW_QUOTE_DOCUMENT_TAB = 'SHOW_QUOTE_DOCUMENT_TAB'
export const SHOW_MEMBER_DOCUMENT_TAB = 'SHOW_MEMBER_DOCUMENT_TAB'
export const SAVE_PROSPECT_DETAILS = 'SAVE_PROSPECT_DETAILS'
export const SET_QUOTE_MEMBERS_RESULT = 'SET_QUOTE_MEMBERS_RESULT'
export const SET_CURRENT_QUOTE_MEMBER = 'SET_CURRENT_QUOTE_MEMBER'
export const UPDATE_CURRENT_MEMBER_INFO_CHANGE = 'UPDATE_CURRENT_MEMBER_INFO_CHANGE'
export const SET_QUOTE_INFORMATION = 'SET_QUOTE_INFORMATION'
export const HANDLE_CONTINUE = 'HANDLE_CONTINUE'


export const UPDATE_MODAL_STATE = 'UPDATE_MODAL_STATE'
export const SHOW_FINAL_POPUP = 'SHOW_FINAL_POPUP'
export const SET_FILTERED_NETWORKS = 'SET_FILTERED_NETWORKS'
export const SHOW_MEDICAL_SERVICES = 'SHOW_MEDICAL_SERVICES'
export const GET_PLAN_TYPE_BY_NETWORK_ID = 'GET_PLAN_TYPE_BY_NETWORK_ID'
export const UPDATE_PRODUCT_TYPE = 'UPDATE_PRODUCT_TYPE'
export const SET_PLAN_ID_FROM_QUOTE_SEARCH = 'SET_PLAN_ID_FROM_QUOTE_SEARCH'
export const SET_CURRENT_QUOTE_MEMBER_TO_NULL = 'SET_CURRENT_QUOTE_MEMBER_TO_NULL'
export const GET_RESIDENT_LOCATION_MASTER_END = 'GET_RESIDENT_LOCATION_MASTER_END'
export const GET_WORK_LOCATION_MASTER_END = 'GET_WORK_LOCATION_MASTER_END'
export const SET_QUOTE_MEMBER_DOCS_SAVED_TRUE = 'SET_QUOTE_MEMBER_DOCS_SAVED_TRUE'
export const GET_VISA_LOCATION_MASTER_END = 'GET_VISA_LOCATION_MASTER_END'
export const CLEAR_MEMBER_DOC = 'CLEAR_MEMBER_DOC'
export const SET_QUOTE_MEMBER_DOCUMENT = 'SET_QUOTE_MEMBER_DOCUMENT'
export const GET_CUSTOMER_INFORMATION_END_V1 = 'GET_CUSTOMER_INFORMATION_END_V1'
export const UPDATE_CUSTOMER_INFORMATION_PARAMS = 'UPDATE_CUSTOMER_INFORMATION_PARAMS'
export const SET_UTM_SOURCE = 'SET_UTM_SOURCE'




